/* eslint-disable jira/filename-case */
const STARRED_AND_RECENT = 'STARRED_AND_RECENT' as const;
const STARRED = 'STARRED' as const;
const MOST_RECENT_ONLY = 'MOST_RECENT_ONLY' as const;

export const ViewOptions: {
	readonly STARRED_AND_RECENT: 'STARRED_AND_RECENT';
	readonly STARRED: 'STARRED';
	readonly MOST_RECENT_ONLY: 'MOST_RECENT_ONLY';
} = {
	STARRED_AND_RECENT,
	STARRED,
	MOST_RECENT_ONLY,
} as const;

export const DefaultViewOption: 'STARRED_AND_RECENT' = ViewOptions.STARRED_AND_RECENT;
